import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Header from '../../common/Header';
import DiagnoiseWizard from './components/diagnoiseWizard';
import { resetState } from './redux/selfDiagnosisActions';
import logoImage from '../../assets/logo.png';

const useStyles = makeStyles(() => ({
  backgroundImage: {
    width: '100%',
    objectFit: 'cover',
    height: 'calc(100vh - 80px)',
    backgroundImage: `url(https://images.squarespace-cdn.com/content/v1/55d8c615e4b001a6d40419a2/1494103933892-NR1CM9WTB2U3HQT05DOR/image-asset.png)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    opacity: 1,
  },
  btn: {
    background: '#00b074',
    borderRadius: 5,
    padding: '13px 0px',
    width: 120,
    textAlign: 'center',
    cursor: 'pointer',
    color: 'white',
    fontWeight: 'bold',
    transition: 'background-color 0.5s ease',
    '&:hover': {
      background: '#019563',
    },
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

function SelfDiagnosis(props) {
  const classes = useStyles();
  const [openDialog, setOpenDialog] = React.useState(false);
  const dispatch = useDispatch();
  return (
    <div>
      <Header />
      <div className={classes.backgroundImage}>
        <div className={classes.overlay}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div>
              {/* eslint-disable-next-line jsx-a11y/alt-text */}
              <img src={logoImage} />
            </div>
            <div
              style={{
                fontSize: 50,
                fontWeight: 'bold',
                color: 'white',
                marginBottom: 50,
                marginTop: 50,
                letterSpacing: 15,
              }}
            >
              SELF - DIAGNOSIS
            </div>
            <div
              className={classes.btn}
              onClick={() => setOpenDialog(!openDialog)}
            >
              START
            </div>
          </div>
        </div>
      </div>
      <DiagnoiseWizard
        open={openDialog}
        onClose={() => {
          dispatch(resetState());
          setOpenDialog(false);
        }}
      />
    </div>
  );
}

export default SelfDiagnosis;
